module.exports = __webpack_public_path__ + "img/people_img_6_1.1b3ba806.png";